import { render, staticRenderFns } from "./WebinarCertificates.vue?vue&type=template&id=50c5b3b2"
import script from "./WebinarCertificates.vue?vue&type=script&lang=js"
export * from "./WebinarCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports